import React from 'react';
import './ExperienceCard.scss';

const ExperienceCard = ({ job }) => {
	return (
		<article className="experience-card">
			<div className="experience-card__header">
				<div className="experience-card__title-section">
					{job.logoUrl && (
						<img
							src={job.logoUrl}
							alt={`${job.company} logo`}
							className="experience-card__logo"
						/>
					)}
					<div>
						<h3 className="experience-card__title">{job.title}</h3>
						<p className="experience-card__company">
							{job.company}
						</p>
					</div>
				</div>
				<div className="experience-card__period">{job.period}</div>
			</div>

			<ul className="experience-card__highlights">
				{job.highlights.map((highlight, index) => (
					<li key={index} className="experience-card__highlight">
						<span className="experience-card__bullet">•</span>
						<span>{highlight}</span>
					</li>
				))}
			</ul>
		</article>
	);
};

export default ExperienceCard;
